
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi,passwordapi } from "../../ApiNames";

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data,
});
export const fetchmsgdatasuccess = (msgdata:any)=>({
    type : 'fetch_msg_data_success',
    payload:msgdata,
});
export const fetchforgotSuccess=(forgotpass:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: forgotpass,
});
export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = orgapi.orgdonations;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};
export const msgdonordata = (uid:any,donationID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,did:donationID};
            const apiname = orgapi.orgdon;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchmsgdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};
export const fetchpassData = (email:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {username:email };
            const apiname = passwordapi.password;
            // const response = await LoginService.getData(apiname,payload)
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchforgotSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

